import account from '@/modules/account'
import balance from '@/modules/balance'
import customer from '@/modules/customer'
import dashboard from '@/modules/dashboard'
import movement from '@/modules/movement'
import product from '@/modules/product'
import user from '@/modules/user'
import auth from '@/modules/auth'
import closure from '@/modules/closure'
import company from '@/modules/company'
import installment from '@/modules/installment'
import expense from '@/modules/expense'
import profit from '@/modules/profit'

export default {
    account,
    balance,
    customer,
    dashboard,
    movement,
    product,
    user,
    auth,
    closure,
    company,
    installment,
    expense,
    profit
}
